import React from "react";
import { useTranslation } from "react-i18next";
import {PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER, DURATION_FILTER_URL_QUERY_PARAMETER, SORT_BY_FILTER_URL_QUERY_PARAMETER} from '../../constants/Query'
import {timeFilters, podcastsTimeFilters, durationFilters, sortByFilters}  from '../../constants/Filter'

const constructQueryString = (defaultParams, forcedParams) => {
  return new URLSearchParams({ ...defaultParams, ...forcedParams }).toString();
}

export function NewsFilter({timeFilter, sortByFilter, urlPrefix}) {
  const { t } = useTranslation();
  let currentParams = {};
  const timeQueryFilter = timeFilters.filter(filter => filter.id === timeFilter)
  const [selectedTimeQueryFilter, setSelectedTimeQueryFilter] = React.useState(timeQueryFilter.length >= 1 ? timeQueryFilter[0] : timeFilters[0])
  currentParams[PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER] = selectedTimeQueryFilter.id;
  const sortByQueryFilter = sortByFilters.filter(filter => filter.id === sortByFilter)
  const [selectedSortByQueryFilter, setSelectedSortByQueryFilter] = React.useState(sortByQueryFilter.length >= 1 ? sortByQueryFilter[0] : sortByFilters[0])
  currentParams[SORT_BY_FILTER_URL_QUERY_PARAMETER] = selectedSortByQueryFilter.id;
  return (
    <div className="l-justify spacing-b-sm center">
      <div className="filter">
        <div className="dropdown">
          <button className="title label-has-dropdown">{t(selectedTimeQueryFilter.title)}</button>
          <div className="dropdown-panel js-sort-panel">
            <ul className="no-bullet">
              {
                timeFilters.map((item, index) =>{
                  return(
                    <li key={`filter-dropdown-${index + 1}`}>
                      <a
                        title={item.title}
                        href={`${urlPrefix}&${constructQueryString(currentParams, { [PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER]: item.id })}`}
                        aria-selected={item.id === selectedTimeQueryFilter.id ? "true" : "false"}>
                        {t(item.title)}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <div className="dropdown">
          <button className="title label-has-dropdown">{t('sort.by', { property_name: t(selectedSortByQueryFilter.title) })}</button>
          <div className="dropdown-panel js-sort-panel">
            <ul className="no-bullet">
              {
                sortByFilters.map((item, index) =>{
                  return(
                    <li key={`filter-dropdown-${index + 1}`}>
                      <a
                        title={item.title}
                        href={`${urlPrefix}&${constructQueryString(currentParams, { [SORT_BY_FILTER_URL_QUERY_PARAMETER]: item.id })}`}
                        aria-selected={item.id === selectedSortByQueryFilter.id ? "true" : "false"}>
                        {t(item.title)}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export function PodcastsFilter({timeFilter, durationFilter, sortByFilter, urlPrefix}) {
  const { t } = useTranslation();
  let currentParams = {};
  const timeQueryFilter = podcastsTimeFilters.filter(filter => filter.id === timeFilter)
  const [selectedTimeQueryFilter, setSelectedTimeQueryFilter] = React.useState(timeQueryFilter.length >= 1 ? timeQueryFilter[0] : podcastsTimeFilters[0])
  currentParams[PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER] = selectedTimeQueryFilter.id;
  const durationQueryFilter = durationFilters.filter(filter => filter.id === durationFilter)
  const [selectedDurationQueryFilter, setSelectedDurationQueryFilter] = React.useState(durationQueryFilter.length >= 1 ? durationQueryFilter[0] : durationFilters[0])
  currentParams[DURATION_FILTER_URL_QUERY_PARAMETER] = selectedDurationQueryFilter.id;
  const sortByQueryFilter = sortByFilters.filter(filter => filter.id === sortByFilter)
  const [selectedSortByQueryFilter, setSelectedSortByQueryFilter] = React.useState(sortByQueryFilter.length >= 1 ? sortByQueryFilter[0] : sortByFilters[0])
  currentParams[SORT_BY_FILTER_URL_QUERY_PARAMETER] = selectedSortByQueryFilter.id;
  return (
    <div className="l-justify spacing-b-sm center">
      <div className="filter">
        <div className="dropdown">
          <button className="title label-has-dropdown">{t(selectedDurationQueryFilter.title)}</button>
          <div className="dropdown-panel js-sort-panel">
            <ul className="no-bullet">
              {
                durationFilters.map((item, index) =>{
                  return(
                    <li key={`filter-dropdown-${index + 1}`}>
                      <a
                        title={item.title}
                        href={`${urlPrefix}&${constructQueryString(currentParams, { [DURATION_FILTER_URL_QUERY_PARAMETER]: item.id })}`}
                        aria-selected={item.id === selectedDurationQueryFilter.id ? "true" : "false"}>
                        {t(item.title)}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <div className="dropdown">
          <button className="title label-has-dropdown">{t(selectedTimeQueryFilter.title)}</button>
          <div className="dropdown-panel js-sort-panel">
            <ul className="no-bullet">
              {
                podcastsTimeFilters.map((item, index) =>{
                  return(
                    <li key={`filter-dropdown-${index + 1}`}>
                      <a
                        title={item.title}
                        href={`${urlPrefix}&${constructQueryString(currentParams, { [PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER]: item.id })}`}
                        aria-selected={item.id === selectedTimeQueryFilter.id ? "true" : "false"}>
                        {t(item.title)}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <div className="dropdown">
          <button className="title label-has-dropdown">{t('sort.by', { property_name: t(selectedSortByQueryFilter.title) })}</button>
          <div className="dropdown-panel js-sort-panel">
            <ul className="no-bullet">
              {
                sortByFilters.map((item, index) =>{
                  return(
                    <li key={`filter-dropdown-${index + 1}`}>
                      <a
                        title={item.title}
                        href={`${urlPrefix}&${constructQueryString(currentParams, { [SORT_BY_FILTER_URL_QUERY_PARAMETER]: item.id })}`}
                        aria-selected={item.id === selectedSortByQueryFilter.id ? "true" : "false"}>
                        {t(item.title)}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
